<div class="col">
    <div class="card" style="width: 100%;  top: 20vh">
        <img class="card-img-top" src="/assets/images/confirmation.png" alt="Card image cap">
        <div class="card-body">
            <h5 class="card-title">{{this.lable}}</h5>
        </div>
    </div>
</div>
<router-outlet></router-outlet>